import React, { useEffect, useState } from 'react';
import { Grid, makeStyles, Snackbar, Button, Divider,
 TextField, Paper, Typography} from '@material-ui/core';
import { withRouter } from 'react-router';
import { Skeleton, Alert } from '@material-ui/lab';
import _ from 'lodash';
import Slide from '@material-ui/core/Slide';
import { useUser } from '../../../../providers/UserContext';
import { functions } from '../../../../firebase/firebase'
import PaperTitle from '../../../components/Orders/OrderPage/PaperTitle';
import { firestore, } from '../../../../firebase/firebase'
import 'react-quill/dist/quill.snow.css';
import SendIcon from '@material-ui/icons/Send';

function SlideTransition(props) {
    return <Slide {...props} direction="down" />;
  }
const useStyles = makeStyles((theme) => ({
  content: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    },
  grid: {
    marginTop: theme.spacing(2),
    padding:'10px',
    maxWidth: '1000px',
    width: '100%',
  },
  checkbox: {
    lineHeight: 2,
    padding:'0px',
    marginTop: '4px',
    marginBottom: '4px',
},
fileInput: {
    '&:hover': {
        cursor: 'pointer',
      },
    alignItems: 'center',
    border: '1px solid #bdbdbd',
    borderRadius:'4px',
    margin:'8px',
    marginTop:'16px',
},
}));

const EmployeeNotif = (props) => {
  const [userData, setUserData] = useState("userDataUserHome" in sessionStorage ? JSON.parse(sessionStorage.getItem("userDataUserHome")) : []);

  const [pageLoading, setPageLoading] = useState(true)

  const classes = useStyles();
  const { users, error, getUsers } = useUser();
  const [sendingEmail, setSendingEmail] = useState(false);

  const [subject, setSubject] = useState("");
  const [content, setContent] = useState("");
  const [emailList, setEmailList] = useState([]);
  const [alertUp, setAlertUp] = useState(false);
  const [alert, setAlert] = useState("");

  const darkMode = JSON.parse(window.localStorage.getItem('colorMode')) === 'dark' ? true : false;
  //grabs users when users set is empty
  useEffect(() => {
    if(!users.length > 0){
      getUsers()
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setPageLoading(true) 
    if(users.length > 0){
        let container = users.filter((user) => ( _.isUndefined(user.employment) || user.employment.active === true ))
        sessionStorage.setItem("userDataUserHome", JSON.stringify(container));
        setUserData(container)  
        setPageLoading(false) 
    }
  }, [users, emailList])

  const sendNotification = async () => {
    setSendingEmail(true);

    try {
        const sendMobileNotification = functions.httpsCallable('sendMobileNotification');

        // Fetch all tokens asynchronously
        const tokenPromises = emailList.map(async (name) => {
            console.log(name);
            const querySnapshot = await firestore
                .collection('fcmTokens')
                .where('userDisplayName', '==', name)
                .get();

            const response = querySnapshot.docs.map((doc) => doc.data());
            return response[0]?.token; // Return the token or undefined
        });

        // Resolve all promises and filter out undefined tokens
        const tokenlist = (await Promise.all(tokenPromises)).filter(Boolean);

        console.log(tokenlist);

        // Send the notification
        const response = await sendMobileNotification({
            tokens: tokenlist,
            body: content,
            title: subject,
            sandbox: process.env.NODE_ENV === 'development',
        });

        console.log('Notification sent!');
        setAlertUp(response.data.success);
        setAlert('Notification(s) sent successfully!');
    } catch (error) {
        console.error('Error sending notification:', error);
        setAlertUp(false);
        setAlert('Failed to send notification(s).');
    } finally {
        setSendingEmail(false);
    }
};


    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        setAlertUp(false);
      }; 
  
      //check if emailList has all the office employees are included in the emailList
      const check4Office = () => {
            return userData.filter(user => user.department === 'Office').map((user) => user.displayName).every((email) => emailList.includes(email))
        };

        const check4Driver = () => {
            return userData.filter(user => user.department === 'Driver/Trucker').map((user) => user.displayName).every((email) => emailList.includes(email))
        }

        const check4Shop = () => {
            return userData.filter(user => user.department === 'Shop').map((user) => user.displayName).every((email) => emailList.includes(email))
        }

        const check4Construction = () => {
            return userData.filter(user => user.department === 'Construction').map((user) => user.displayName).every((email) => emailList.includes(email))
        }

        const check4Grain = () => {
            return userData.filter(user => user.department === 'Grain').map((user) => user.displayName).every((email) => emailList.includes(email))
        }

  return (
    <div className={classes.content}>

      {!pageLoading && !error ?
      <Grid container style={{margin:'10px'}} spacing={2}>
      <Grid item className={classes.content} spacing={2} xs={12}>
        {alertUp ?
            <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={true} autoHideDuration={4500} onClose={handleClose} TransitionComponent={SlideTransition}>
                <Alert onClose={handleClose} style={{backgroundColor:'green', color:'white'}} severity="success" sx={{ width: '100%' }}>
                    {alert}
                </Alert>
            </Snackbar>
        :null}
        <Paper className={classes.grid} >
            <PaperTitle title="Send Mobile Notification" />
            <Divider style={{margin:'10px'}}/>
            <Grid>
                <Grid container spacing={2}>
                    <Grid item xs={12} className={classes.table}>
                        <TextField
                            id="subject"
                            label="Title"
                            size="small"
                            fullWidth
                            variant="outlined"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} className={classes.table}>
                        <TextField
                            id="content"
                            label="Body"
                            size="small"
                            fullWidth
                            multiline
                            rows={15}
                            variant="outlined"
                            value={content}
                            onChange={(e) => setContent(e.target.value)}
                        />
                    </Grid>
                </Grid>

            </Grid>
            <Divider style={{margin:'10px'}}/>
            <Grid item xs={12}>
                    <Button 
                        fullWidth style={{marginTop:'10px',}}
                        variant="contained" color="primary" disabled={sendingEmail || subject === '' || content === '' || emailList.length === 0 }
                        onClick={() => sendNotification(emailList)} startIcon={<SendIcon/>}
                    > {sendingEmail ? 'Sending...' : 'Send Notification'}</Button>
                </Grid>
        </Paper>
        </Grid>
        <Grid className={classes.content} item spacing={2} xs={12}>
            <Paper className={classes.grid} >
                <PaperTitle title={emailList.length > 0 ? "Recipients (" + emailList.length + ")" : "Recipients "} />
                <Grid item xs={12} style={{padding:'10px'}}>
                    <Button variant={emailList.length !== userData.length?"contained":"outlined"} size="small" onClick={
                        () =>emailList.length !== userData.length? setEmailList(userData.map((user) => user.displayName)) : setEmailList([])
                    }>All</Button>

                    <Button
                    variant={check4Office() ? "outlined" : "contained"}
                    size="small"
                    style={{marginLeft: '2px'}}
                    onClick={() => {
                        const officeEmails = userData
                        .filter(user => user.department === 'Office')
                        .map(user => user.displayName);
                        if (!check4Office()) {
                        // Add all office emails to the emailList
                            setEmailList([...emailList, ...officeEmails]);
                        } else {
                        // Remove office emails from the emailList
                            setEmailList(emailList.filter(email => !officeEmails.includes(email)));
                        }
                    }}
                    >
                    Office
                    </Button>
                    <Button
                    variant={check4Shop() ? "outlined" : "contained"}
                    size="small"
                    style={{marginLeft: '2px'}}
                    onClick={() => {
                        const officeEmails = userData
                        .filter(user => user.department === 'Shop')
                        .map(user => user.displayName);
                        if (!check4Shop()) {
                        // Add all office emails to the emailList
                            setEmailList([...emailList, ...officeEmails]);
                        } else {
                        // Remove office emails from the emailList
                            setEmailList(emailList.filter(email => !officeEmails.includes(email)));
                        }
                    }}
                    >
                    Shop
                    </Button>
                    <Button
                    variant={check4Construction() ? "outlined" : "contained"}
                    size="small"
                    style={{marginLeft: '2px'}}
                    onClick={() => {
                        const officeEmails = userData
                        .filter(user => user.department === 'Construction')
                        .map(user => user.displayName);
                        if (!check4Construction()) {
                        // Add all office emails to the emailList
                            setEmailList([...emailList, ...officeEmails]);
                        } else {
                        // Remove office emails from the emailList
                            setEmailList(emailList.filter(email => !officeEmails.includes(email)));
                        }
                    }}
                    >
                    Construction
                    </Button>
                    <Button
                    variant={check4Driver() ? "outlined" : "contained"}
                    size="small"
                    style={{marginLeft: '2px'}}
                    onClick={() => {
                        const officeEmails = userData
                        .filter(user => user.department === 'Driver/Trucker')
                        .map(user => user.displayName);
                        if (!check4Driver()) {
                        // Add all office emails to the emailList
                            setEmailList([...emailList, ...officeEmails]);
                        } else {
                        // Remove office emails from the emailList
                            setEmailList(emailList.filter(email => !officeEmails.includes(email)));
                        }
                    }}
                    >
                    Driver/Trucker
                    </Button>
                    <Button
                    variant={check4Grain() ? "outlined" : "contained"}
                    size="small"
                    style={{marginLeft: '2px'}}
                    onClick={() => {
                        const officeEmails = userData
                        .filter(user => user.department === 'Grain')
                        .map(user => user.displayName);
                        if (!check4Grain()) {
                        // Add all office emails to the emailList
                            setEmailList([...emailList, ...officeEmails]);
                        } else {
                        // Remove office emails from the emailList
                            setEmailList(emailList.filter(email => !officeEmails.includes(email)));
                        }
                    }}
                    >
                    Grain
                    </Button>
                </Grid>
                <Divider style={{margin:'10px'}}/>
                <Grid>
                    <Grid container style={{
                        maxHeight: '400px',
                        overflowY: 'auto',
                        padding: '10px'}}>
                        {userData.sort ((a, b) => a.displayName.localeCompare(b.displayName))
                        .map((user) => (
                            <Grid item xs={2} key={user.id}>
                                <Typography onClick={() => emailList.includes(user.displayName)? setEmailList(emailList.filter((email) => email !== user.displayName)) 
                                :setEmailList([...emailList, user.displayName])}
                                 variant="body2" style={emailList.includes(user.displayName)?{marginBottom: '10px', 
                                    color: darkMode?'#000000':'#000000',
                                    backgroundColor:'#FFBF00', cursor:'pointer', fontWeight:'bold', borderRadius:'5px'}
                                 :{marginBottom: '10px', cursor:'pointer'}}>{user.displayName}</Typography>
                            </Grid>
                        ))}
                    </Grid>
                    <Divider/>
                </Grid>
            </Paper>
        </Grid>
 
        </Grid>
        :
        <Grid >
          <Skeleton variant='rect' width={'45vw'} height={'85vh'} style={{marginTop: '85px'}}/>
        </Grid>
      }
    </div>
  )
}

export default withRouter(EmployeeNotif);